module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Cloud-upload-f8f0a9a03b87436909efd55502dcf4e0.svg";